package tta.destinigo.talktoastro.shared.platform

sealed interface PlatformType {
    data object Web : PlatformType
    data object Android : PlatformType
    data object iOS : PlatformType
    data object Desktop : PlatformType
}